"use strict";

var ExportButton = require("app/shared/components/ExportButton/export-button");

var ExportActivitiesButton = React.createClass({
  propTypes: {
    onExport: React.PropTypes.func.isRequired,
    skipOptions: React.PropTypes.bool
  },
  getExtraOptions: function(selectionValue) {
    return {
      includeOrgPersonData: (selectionValue >= 1 ? 1 : 0),
      includeMetrics: (selectionValue >= 2 ? 1 : 0)
    };
  },
  render: function() {
    let buttonText = this.props.skipOptions ? "Exportar histórico" : "Exportar";

    let options = [
      {value: 0, checked: true, text: "Tarefas"},
      {value: 1, checked: false, text: "Tarefas + detalhes de Empresas e Pessoas"},
      {value: 2, checked: false, text: "Tarefas + detalhes de Empresas e Pessoas + detalhes de Métricas"}];
    return <ExportButton onExport={this.props.onExport}
      getExtraOptions={this.getExtraOptions}
      options={options}
      skipOptions={this.props.skipOptions}
      buttonText={buttonText}
      exportName="atividade" />
  }
});

module.exports = ExportActivitiesButton;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ExportActivitiesButton/export-activities-button.jsx